import React from "react";
import useWizardController from "./useWizardController";

export const WizardContext = React.createContext();

export default React.memo(({children, stepsMap, stepPaths, initialStep, initialPath, initialState}) => {
    const controller = useWizardController({stepsMap, stepPaths, initialStep, initialPath, initialState});

    return <WizardContext.Provider value={controller}>
        {children}
    </WizardContext.Provider>
});
